export function getRange(minValue, maxValue, minLimit, maxLimit, ww, baseWidth, minRatio, maxRatio) {
  const widthRatio = ww / baseWidth;
  let adjustedMin = minValue * Math.max(widthRatio, minRatio);
  let adjustedMax = maxValue * Math.max(widthRatio, maxRatio);
  if(minLimit != '' && adjustedMin >= minLimit) adjustedMin = minLimit
  if(maxLimit != '' && adjustedMax >= maxLimit) adjustedMax = maxLimit
  return [adjustedMin, adjustedMax];
}